module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-image-sp-a0612d31b2adef7bf40c96dd013e8ca0.jpg";